<template>
  <b-container v-if="page === 'LIST_TEMPLATE'" data-app fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-file"></i>
          {{
            $t(
                    "public.views.Pages.Professional.Organization.HistoricClinics.titleList"
            )
          }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button v-if="
          checkPermissionProfessional('ORGANIZATION_HISTORIC', ['CREATE'])
        " class="mr-2" style="right" variant="success" @click="viewCreateTemplate">{{
  $t(
          "public.views.Pages.Professional.Organization.HistoricClinics.btnCreate"
  )
}}
        </b-button>
      </template>
      <template v-slot:body>
        <v-card-title>
          <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line>
            <template slot="label">{{
              $t(
                          "public.views.Pages.Professional.Organization.HistoricClinics.search"
              )
            }}
            </template>
          </v-text-field>
        </v-card-title>
        <v-data-table :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'fas fa-arrow-left',
          lastIcon: 'fas fa-arrow-right',
          prevIcon: 'fas fa-minus',
          nextIcon: 'fas fa-plus',
          'items-per-page-options': [10, 25, 50],
        }" :headers="headers" :items="templates" :items-per-page="10" :search="search" item-key="uuid">
          <template v-slot:item.uuid="{ item }">
            <div class="div-table-data">
              <button v-if="
                checkPermissionProfessional('ORGANIZATION_HISTORIC', [
                  'CREATE',
                ])
              " id="btnClone" class="item" v-on:click="viewCloneTemplate(item.uuid)">
                <i class="ri-file-copy-line"></i>
              </button>
              <b-popover v-if="
                checkPermissionProfessional('ORGANIZATION_HISTORIC', [
                  'CREATE',
                ])
              " placement="botton" target="btnClone" triggers="hover focus">
                <template #title>{{
                  $t(
                                  "public.views.Pages.Professional.Organization.HistoricClinics.btnClone"
                  )
                }}
                </template>
              </b-popover>
              <button v-if="
                checkPermissionProfessional('ORGANIZATION_HISTORIC', [
                  'DELETE',
                ])
              " id="btnDelete" class="item" v-on:click="viewDeleteTemplate(item.uuid)">
                <i class="ri-delete-bin-line"></i>
              </button>
              <b-popover v-if="
                checkPermissionProfessional('ORGANIZATION_HISTORIC', [
                  'DELETE',
                ])
              " placement="botton" target="btnDelete" triggers="hover focus">
                <template #title>{{
                  $t(
                                  "public.views.Pages.Professional.Organization.HistoricClinics.btnDelete"
                  )
                }}
                </template>
              </b-popover>
            </div>
          </template>
        </v-data-table>
      </template>
    </iq-card>
  </b-container>
  <b-container v-else fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-file"></i>
          {{
            $t(
                    "public.views.Pages.Professional.Organization.HistoricClinics.titleInformation"
            )
          }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button ref="btnShowNewContact" class="mr-2" style="right" variant="primary" @click="listTemplate">{{
          $t(
                  "public.views.Pages.Professional.Organization.HistoricClinics.btnBack"
          )
        }}
        </b-button>
        <b-button v-if="checkPermissionProfessional('ORGANIZATION_HISTORIC', ['EDIT'])" ref="btnShowNewContact"
          class="mr-2" style="right" variant="success" @click="saveForm">
          <div v-if="action === 'CLONE'">
            {{
              $t(
                        "public.views.Pages.Professional.Organization.HistoricClinics.btnCloneCreate"
              )
            }}
          </div>
          <div v-else>
            {{
              $t(
                        "public.views.Pages.Professional.Organization.HistoricClinics.btnSave"
              )
            }}
          </div>
        </b-button>
      </template>
      <template v-slot:body>
        <b-form-group label-for="name">
          <template slot="label">{{
            $t(
                      "public.views.Pages.Professional.Organization.HistoricClinics.titleInput"
            )
          }}: *
          </template>
          <b-form-input id="name" v-model="name" :disabled="disabled" type="text" v-bind:class="{
            'text-danger': isFormNameErrors,
            'is-invalid': isFormNameErrors,
          }" @blur="checkName(name)"></b-form-input>
          <ul v-if="isFormNameErrors">
            <li v-for="(error, index) in validatorStep1.getErrors('name')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
      </template>
    </iq-card>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-folder-plus"></i>
          {{
            $t(
                    "public.views.Pages.Professional.Organization.HistoricClinics.titleInformation1"
            )
          }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button v-if="checkPermissionProfessional('ORGANIZATION_HISTORIC', ['EDIT'])" ref="btnShowNewContact"
          class="btn-flat" style="right" variant="success" @click="createTab">{{
            $t(
                    "public.views.Pages.Professional.Organization.HistoricClinics.btnCreateTab"
            )
          }}
        </b-button>
      </template>
      <template v-slot:body>
        <tab-nav :tabs="true">
          <tab-nav-items v-for="(option, index) in tabs" :id="'tab-nav-' + index" :key="index" :active="index < 1"
            :ariaSelected="true" :href="'#tab-' + index" role="tab">
            <template v-slot:title>
              <b-form-input v-model="option.name"></b-form-input>
            </template>
          </tab-nav-items>
        </tab-nav>
        <tab-content>
          <tab-content-item v-for="(option, index) in tabs" :id="'tab-' + index" :key="index" :active="index < 1">
            <div class="test-survey-builder">
              <QuestionsView :questions="option.questionsList" :readOnly="false" />
              <div v-if="addQuestion">
                <SurveyBuilder :options="sampleQuestion" :tab="index" />
              </div>
              <div class="text-right">
                <b-button v-if="
                  checkPermissionProfessional('ORGANIZATION_HISTORIC', [
                    'CREATE',
                  ])
                " class="mt-5" variant="success" v-on:click="addNewQuestion(index)">
                  {{
  $t(
                  "public.views.Pages.Professional.Organization.HistoricClinics.btnNewQuestion"
  )
                  }}
                </b-button>
              </div>
            </div>
          </tab-content-item>
        </tab-content>
      </template>
    </iq-card>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";
import validator from "vue-m-validator";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import Survey from "../../../../json/Survey";

import SurveyBuilder from "../../../../components/survey/SurveyBuilder";
import QuestionsView from "../../../../components/survey/QuestionsView";

import historicService from "../../../../services/historic";
import professionalService from "../../../../services/professional";
import utilsService from "../../../../services/utils";

export default {
  name: "HistoricClinics",

  mounted() {
    xray.index();
    this.getAllTemplates();
    this.$root.$on("change-colums", (columns) => {
      this.numCol = columns;
    });
    this.$root.$on("add-update-question", (q, tab) => {
      this.updateQuestionsList(q, tab);
    });

    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_HISTORIC_CLINIC_TEMPLATE", info: "" });
  },
  components: { SurveyBuilder, QuestionsView, "vue-dropzone": vue2Dropzone },
  computed: {
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
  },
  methods: {
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    notFirst() {
      this.isFirstRun = false;
    },
    listTemplate() {
      this.page = "LIST_TEMPLATE";
      this.getAllTemplates();
    },
    viewCreateTemplate() {
      this.cleanCreate();
      this.action = "CREATE";
      this.page = "CREATE_TEMPLATE";
    },
    viewCloneTemplate(uuid) {
      this.getTemplate(uuid);
      this.cleanCreate();
      this.action = "CLONE";
      this.page = "CREATE_TEMPLATE";
    },
    viewUpdateTemplate(uuid) {
      this.getTemplate(uuid);
      this.cleanCreate();
      this.action = "UPDATE";
      this.page = "CREATE_TEMPLATE";
    },
    viewDeleteTemplate(uuid) {
      this.deleteTemplate(uuid);
      this.page = "LIST_TEMPLATE";
    },
    cleanCreate() {
      this.name = "";
      this.uuid = "";
      this.professional = localStorage.getItem("userId");
      this.clearTabs();
      this.createTab();
    },
    deleteTemplate(uuid) {
      let self = this;

      this.$awn.asyncBlock(
        historicService.deleteTemplate(uuid),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_HISTORIC_CLINIC_TEMPLATE", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.HistoricClinics.notification.descDeleteTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "historicService.deleteTemplate",
            module: "view-pages-professional-organization-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              uuid: uuid
            })
          });
        },
        " "
      );
    },
    cloneTemplate() {
      let self = this;

      let data = {
        uuid: this.uuid,
        name: this.name,
        professional: this.professional,
        template: true,
        tabs: this.tabs,
      };

      this.$awn.asyncBlock(
        historicService.cloneTemplate(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_HISTORIC_CLINIC_TEMPLATE", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.HistoricClinics.notification.descCloneTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "historicService.cloneTemplate",
            module: "view-pages-professional-organization-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    updateTemplate() {
      let self = this;

      let data = {
        uuid: this.uuid,
        name: this.name,
        professional: this.professional,
        template: true,
        tabs: this.tabs,
      };

      this.$awn.asyncBlock(
        historicService.updateTemplate(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_HISTORIC_CLINIC_TEMPLATE", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.HistoricClinics.notification.descRefreshTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "historicService.updateTemplate",
            module: "view-pages-professional-organization-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    getTemplate(uuid) {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.findHistoric(this.professional, uuid),
        (response) => {
          if (response) {
            self.uuid = response.data.uuid;
            self.name = response.data.name;
            self.numCol = response.data.numCol;
            self.tabs = response.data.tabs;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.findHistoric",
            module: "view-pages-professional-organization-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional, uuid: uuid
            })
          });
        },
        " "
      );
    },
    async getAllTemplates() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.getAllTemplates(this.professional),
        (response) => {
          if (response) {
            self.templates = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllTemplates",
            module: "view-pages-professional-organization-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional
            })
          });
        },
        " "
      );
    },
    checkFormStep1() {
      this.checkName(this.name);
    },
    saveForm(evt) {
      evt.preventDefault();

      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        if (this.action === "CREATE") {
          this.createTemplate();
        }
        if (this.action === "UPDATE") {
          this.updateTemplate();
        }
        if (this.action === "CLONE") {
          this.cloneTemplate();
        }
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Organization.HistoricClinics.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.HistoricClinics.notification.descErrorSave"
          ),
          type: "error",
        });
      }
    },
    createTemplate() {
      let self = this;

      let data = {
        uuid: this.uuid,
        numCol: this.numCol,
        name: this.name,
        professional: this.professional,
        template: true,
        tabs: this.tabs,
      };

      this.$awn.asyncBlock(
        historicService.saveTab(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_HISTORIC_CLINIC_TEMPLATE", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.HistoricClinics.notification.descSaveTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "historicService.saveTab",
            module: "view-pages-professional-organization-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    createTab() {
      let tab = {
        order: this.tabs.length,
        name: this.$i18n.t(
          "public.views.Pages.Professional.Organization.HistoricClinics.createTab"
        ),
        questionsList: [],
      };

      this.tabs.push(tab);
    },
    clearTabs() {
      this.tabs = [];
    },
    updateQuestionsList(question, tab) {
      if (this.tabs[tab].questionsList === null) {
        this.tabs[tab].questionsList = [];
      }
      const questionIndex = this.tabs[tab].questionsList.length + 1;
      question.order = questionIndex;
      if (questionIndex >= 0) {
        this.tabs[tab].questionsList.splice(questionIndex, 1, question);
      } else {
        this.tabs[tab].questionsList.push(JSON.parse(JSON.stringify(question)));
      }
      this.addQuestion = false;
      this.$root.$emit("selected-question", null);
    },
    addNewQuestion(index) {
      this.sampleQuestion = JSON.parse(JSON.stringify(Survey));
      this.sampleQuestion.uuid = this.getGUID();
      this.sampleQuestion.order = index;
      this.addQuestion = true;
    },
    getGUID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }

      return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`;
    },
    //Validation form
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.HistoricClinics.errors.erName"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkPatient(_patient) {
      const PATIENT = _patient != null ? _patient.toString() : null;
      const RULE_1 = {
        expression: !PATIENT || PATIENT === "",
        name: "patient",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.HistoricClinics.errors.erPatient"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkProfessional(_professional) {
      const PROFESSIONAL =
        _professional != null ? _professional.toString() : null;
      const RULE_1 = {
        expression: !PROFESSIONAL || PROFESSIONAL === "",
        name: "professional",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.HistoricClinics.errors.erProfessional"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
  },

  data() {
    return {
      numCol: "12",
      disabled: false,
      isFirstRun: true,

      search: "",
      action: "",
      page: "LIST_TEMPLATE",
      validatorStep1: validator,
      tabs: [],
      name: "",
      uuid: "",
      professional: localStorage.getItem("userId"),
      patient: "",
      addQuestion: false,

      templates: [],
      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.HistoricClinics.headers.name"
          ),
          align: "start",
          value: "name",
        },
        { text: "", value: "uuid" },
      ],
    };
  },
};
</script>
